import { useEffect, useState } from "react";
import { api, API, getToken, errText } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Download, Plus, ExternalLink, Printer } from "lucide-react";

export default function TablesTab() {
  const [tables, setTables] = useState([]);
  const [name, setName] = useState("");
  const token = getToken();

  const load = () => api.get("/admin/tables").then(({ data }) => setTables(data));

  useEffect(() => {
    load();
  }, []);

  const add = async () => {
    if (!name.trim()) return;
    try {
      await api.post("/admin/tables", { name });
      setName("");
      toast.success("Bord tillagt");
      load();
    } catch (e) {
      toast.error(errText(e));
    }
  };

  const remove = async (t) => {
    if (!window.confirm(`Ta bort ${t.name}? QR-koden slutar fungera.`)) return;
    await api.delete(`/admin/tables/${t.id}`);
    load();
  };

  return (
    <div>
      <div className="flex flex-wrap items-end gap-3 mb-8">
        <div className="flex-1 min-w-[200px]">
          <p className="text-[0.65rem] uppercase tracking-widest mb-1" style={{ color: "var(--ink-soft)" }}>
            Nytt bord
          </p>
          <input className="input-line font-sans-d text-sm" placeholder="t.ex. Bord 4" value={name} onChange={(e) => setName(e.target.value)} data-testid="table-name-input" />
        </div>
        <button className="btn-invite btn-solid text-[0.6rem] px-4 py-2.5" onClick={add} data-testid="add-table-btn">
          <Plus className="w-3.5 h-3.5" /> Skapa QR-kod
        </button>
        <a href="/admin/print" className="btn-invite text-[0.6rem] px-4 py-2.5 no-underline" data-testid="print-all-cards-btn">
          <Printer className="w-3.5 h-3.5" /> Skriv ut bordskort
        </a>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {tables.map((t) => (
          <div key={t.id} className="p-5 text-center" style={{ border: "1px solid rgba(212,185,160,0.5)", backgroundColor: "rgba(255,255,255,0.6)" }} data-testid={`table-card-${t.name}`}>
            <p className="label-caps text-xs mb-3" style={{ color: "var(--ink)" }}>
              {t.name}
            </p>
            <img src={`${API}/admin/tables/${t.id}/qr?auth=${token}`} alt={`QR ${t.name}`} className="w-40 h-40 mx-auto" />
            <p className="text-[0.65rem] mt-2" style={{ color: "var(--ink-soft)" }}>
              {t.photo_count} foton uppladdade
            </p>
            <div className="flex justify-center gap-1 mt-3">
              <a href={`/admin/print/${t.id}`} className="p-2 opacity-60 hover:opacity-100" title="Skriv ut bordskort" data-testid={`print-card-${t.name}`}>
                <Printer className="w-4 h-4" />
              </a>
              <a href={`${API}/admin/tables/${t.id}/qr?auth=${token}`} download={`${t.name}-qr.png`} className="p-2 opacity-60 hover:opacity-100" title="Ladda ner QR" data-testid={`download-qr-${t.name}`}>
                <Download className="w-4 h-4" />
              </a>
              <a href={`/photos/${t.code}`} target="_blank" rel="noopener noreferrer" className="p-2 opacity-60 hover:opacity-100" title="Öppna uppladdningssida" data-testid={`open-upload-${t.name}`}>
                <ExternalLink className="w-4 h-4" />
              </a>
              <button onClick={() => remove(t)} className="p-2 opacity-60 hover:opacity-100" title="Ta bort" data-testid={`delete-table-${t.name}`}>
                <Trash2 className="w-4 h-4" style={{ color: "var(--burgundy)" }} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
